import { render, staticRenderFns } from "./TourController.vue?vue&type=template&id=bdf32ffc&"
import script from "./TourController.vue?vue&type=script&lang=js&"
export * from "./TourController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports